module.exports = __webpack_public_path__ + "img/40_00_000_814.cee46597.jpg";